(() => {

  function attachEventListeners() {
    let formElements = document.querySelectorAll('[required][data-required-message]');

      formElements.forEach((element) => {
        if (!('requiredMessageListeners' in element.dataset) || element.dataset.requiredMessageListeners !== 'true') {
          element.addEventListener('invalid', handleInvalidInput);

          if (element.tagName === 'select') {
            element.addEventListener('change', handleFieldChange);
          }
          else {
            element.addEventListener('input', handleFieldChange);
          }

          element.dataset.requiredMessageListeners = 'true';
        }
      });

  }

  function handleInvalidInput(event) {
    // Get the input element.
    const formInput = event.target;

    if (formInput.hasAttribute('required')) {
      // Get the validation message.
      const errorMessage = formInput.dataset.requiredMessage;

      // We'll handle this differently if this is a group of inputs (radios/checkboxes).
      if (formInput.type === 'radio' || formInput.type === 'checkbox') {
        // Retrieve all inputs with the same name value.
        const groupElements = document.querySelectorAll(`[name='${formInput.name}']`);

        // If there is more than one checkbox/radio button, loop through them all and set
        // the invalid message.
        if (groupElements.length > 1) {

          for (let i = 0; i < groupElements.length; i++) {
            const element = groupElements.item(i);
            element.setCustomValidity(errorMessage);
          }

        }
        else {
          // Just one checkbox/radio. Set the message.
          formInput.setCustomValidity(errorMessage);
        }
      }
      else {
        // Set the error message;
        formInput.setCustomValidity(errorMessage);
      }
    }
    else {
      // Element is no longer required. Remove any validation messages.
      formInput.setCustomValidity('');
    }

    // Lastly, let's scroll to the first invalid input.
    const invalidFields = document.querySelectorAll('[required]:invalid');

    if (invalidFields.length > 0) {
      const firstInvalidField = invalidFields.item(0);

      let scrollTo = firstInvalidField.getBoundingClientRect().top + window.scrollY - getMastheadHeight();

      setTimeout(() => {
        window.scrollTo({
          top: scrollTo,
          left: 0,
          behavior: 'auto'
        });
      }, 50);

    }

  }

  function handleFieldChange(event) {
    // Get the input element.
    const formInput = event.target;

    if (formInput.hasAttribute('required')) {
      // We'll handle this differently if this is a group of inputs (radios/checkboxes).
      if (formInput.type === 'radio' || formInput.type === 'checkbox') {
        // Retrieve all inputs with the same name value.
        const groupElements = document.querySelectorAll(`[name='${formInput.name}']`);

        // Reset the error message for each element in the group.
        groupElements.forEach((element) => {
          element.setCustomValidity('');
        });
      }
      else {
        // Reset the error message.
        formInput.setCustomValidity('');
      }
    }

  }

  function getMastheadHeight() {
    return document.querySelector('.masthead').offsetHeight;
  }

  document.addEventListener('DOMContentLoaded', () => {
    attachEventListeners();

    const appObserver = new MutationObserver(() => {
      attachEventListeners();
    });

    appObserver.observe(
      document.getElementById('app'),
      { attributes: false, childList: true, subtree: true }
    );
  });
})();